/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportHolidaysCommand
 */
export interface ImportHolidaysCommand {
    /**
     * 
     * @type {string}
     * @memberof ImportHolidaysCommand
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof ImportHolidaysCommand
     */
    state: string;
    /**
     * 
     * @type {number}
     * @memberof ImportHolidaysCommand
     */
    year: number;
}

/**
 * Check if a given object implements the ImportHolidaysCommand interface.
 */
export function instanceOfImportHolidaysCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "year" in value;

    return isInstance;
}

export function ImportHolidaysCommandFromJSON(json: any): ImportHolidaysCommand {
    return ImportHolidaysCommandFromJSONTyped(json, false);
}

export function ImportHolidaysCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportHolidaysCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'country': json['country'],
        'state': json['state'],
        'year': json['year'],
    };
}

export function ImportHolidaysCommandToJSON(value?: ImportHolidaysCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'country': value.country,
        'state': value.state,
        'year': value.year,
    };
}

